<template>
  <div :class="{ loader: true, fadeout: fadeoutLoader }">
    <img class="logo pulse" src="@/assets/logos/platinum-logo-450x225.png" />
  </div>
</template>
<!-- Scripts-->
<script>
export default {
  name: "LoaderPartial",
  props: {
    fadeoutLoader: Boolean,
  },
};
</script>
<!-- Styles -->
<style scoped>
.logo {
  width: 80%;
  max-width: 450px;
  margin: auto;
}
.loader {
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #000;
  color: white;
  font-size: 32px;
  overflow: hidden;
  text-align: center;
  position: fixed;
  z-index: 3;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
}

.fadeout {
  animation: fadeout 1s forwards;
}

@keyframes fadeout {
  to {
    opacity: 0;
    visibility: hidden;
  }
}

.pulse {
  animation-name: pulse;
  animation-duration: 3000ms;
  transform-origin: 70% 70%;
  animation-iteration-count: infinite;
  animation-timing-function: linear;
}

@keyframes pulse {
  0% {
    transform: scale(0.9);
  }
  50% {
    transform: scale(1);
  }
  100% {
    transform: scale(0.9);
  }
}
</style>